module.exports = "query GetPlansDescriptions {\n  plansDescriptions {\n    ...PlanDescriptionFragment\n  }\n}\n"